import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-xl-4" }
const _hoisted_2 = { class: "card bg-light pricing-header" }
const _hoisted_3 = {
  xyz: "fade up-2 duration-6 delay-1",
  class: "text-primary mb-4 xyz-in"
}
const _hoisted_4 = {
  xyz: "fade up-2 duration-6 delay-2",
  class: "mb-2 xyz-in"
}
const _hoisted_5 = {
  xyz: "fade up-2 duration-6 delay-2",
  class: "mb-2 xyz-in"
}
const _hoisted_6 = {
  class: "btn lg xyz-in bg-green sh",
  xyz: "fade up-2 duration-6 delay-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/image-2.svg",
    alt: "Finda"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($setup.strings.pricing[1]), 1),
      _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.sub_title()), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString($setup.strings.pricing[3]), 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString($setup.strings.pricing[4]), 1),
      _hoisted_7
    ])
  ]))
}